import { render, staticRenderFns } from "./PsLateralBar.vue?vue&type=template&id=2c17ce79&scoped=true&"
import script from "./PsLateralBar.vue?vue&type=script&lang=js&"
export * from "./PsLateralBar.vue?vue&type=script&lang=js&"
import style0 from "./PsLateralBar.vue?vue&type=style&index=0&id=2c17ce79&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17ce79",
  null
  
)

export default component.exports